export default __webpack_public_path__ + "static/media/sushi-icon.cafbbf13.svg";